module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 12-9d57871ebd8116403068f889e72f2470.jpg";